import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPersonLock16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconPersonLock16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m6.056 6.857.144-.02V7.94a3 3 0 0 1-.216-.052A3.8 3.8 0 0 0 3 11.6V13h3.2v1H2v-2.4a4.8 4.8 0 0 1 2.8-4.364A3 3 0 1 1 9.8 5h-1a2 2 0 1 0-2.744 1.857M8 8.167V8a2.4 2.4 0 0 1 4.8 0v.166A2 2 0 0 1 14 10v2a2 2 0 0 1-2 2H8.8a2 2 0 0 1-2-2v-2A2 2 0 0 1 8 8.166M8.2 9.2a1 1 0 0 0-.4.8v2a1 1 0 0 0 1 1H12a1 1 0 0 0 1-1v-2a1 1 0 0 0-.4-.8zM11.8 8A1.4 1.4 0 1 0 9 8zm-.8 3a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPersonLock16);
